import {
  collapseNewlines,
  collapseWhitespace,
  decodeHtmlEntities,
  stripLineWhitespace,
  stripTags,
} from './converterUtils';

export function convertToPlainText(html: string): string {
  let text = collapseWhitespace(html);

  // Replace block-level closing tags with newlines
  text = text.replace(/<\/(?:p|li|ul|ol)>/gi, '\n');

  // Replace <br> variants with newline
  text = text.replace(/<br\s*\/?>/gi, '\n');

  // Strip all remaining HTML tags
  text = stripTags(text);

  // Decode HTML entities
  text = decodeHtmlEntities(text);

  // Strip leading/trailing spaces and tabs from every line
  text = stripLineWhitespace(text);

  // Collapse 3+ consecutive newlines to 2
  text = collapseNewlines(text);

  return text.trim();
}
